import './utils/kickstart';

// Utils
import { max, sum } from 'd3-array';
import { nest } from 'd3-collection';
import { select } from 'd3-selection';
import debounce from 'lodash.debounce';
import { curveStepBefore } from 'd3-shape';
import { getSortByString } from './utils/sorters';
import { loadJsonScript } from './utils/load-json-script';
import {
  dateParser,
  dateFormat,
  pctFormat,
  monthFormat,
} from './utils/d3-utils';
import { intcomma } from 'journalize';

// Colors
import {
  SCHOOLS_LIGHT_BLUE,
  SCHOOLS_DARK_BLUE,
  SCHOOLS_LIGHT_GREY,
  SCHOOLS_ORANGE,
  SCHOOLS_HIGH,
  SCHOOLS_MIDDLE,
  SCHOOLS_ELEM,
} from './colors';

// Translation
import { __ } from './utils/i18n';

// Navbar
import './components/navbar';

// Charts
import Changelog from './components/Changelog.svelte';
import StackedBar from './components/StackedBar.svelte';
import SchoolsMap from './components/schools/SchoolsMap.svelte';
import DistrictLookupTable from './components/schools/DistrictLookupTable.svelte';

import './components/linklist';

///////////////////MODAL/////////////////////////////////////

var modal = document.querySelector('.m-outer-container');
import * as focusTrap from 'focus-trap'; // ESM
var contentContainer = document.querySelector('.m-content-container');
const trap = focusTrap.createFocusTrap('.m-content-container', {
  onActivate: () => contentContainer.classList.add('is-active'),
  onDeactivate: () => contentContainer.classList.remove('is-active'),
  initialFocus: () => document.querySelector('.m-content-container'),
  escapeDeactivates: false,
});

trap.activate();

// REWRITE THIS TO TARGET MAIN INSTEAD
var body = document.querySelector('body');
var main = document.querySelector('main');
var modal = document.querySelector('.m-outer-container');
var continueButton = document.querySelector('#continue-to-page');
var agreementCheckbox = document.querySelector('#agreement-checkbox');
// screenreader text w/ modal description
var screenreaderText = document.querySelector('.screenreader-text');

function freezeBody() {
  body.style.overflow = 'hidden';
  main.setAttribute('aria-hidden', 'true');
}
function unfreezeBody() {
  body.style.overflow = 'auto';
  main.setAttribute('aria-hidden', 'false');
  trap.deactivate();
  // modal?.setAttribute('aria-hidden', 'true');
}

freezeBody();
// if checkbox is checked, make "Continue to page clickable"

function toggleCheckbox(e) {
  // if it's the return key, also make it a click
  if (e.which == 13) {
    e.target.click();
  }
  let cb = e.target;
  if (cb.checked) {
    continueButton.disabled = false;

    // unlock the continue button
  } else {
    continueButton.disabled = true;
  }
}

agreementCheckbox.addEventListener('click', toggleCheckbox);
agreementCheckbox.addEventListener('keypress', toggleCheckbox);

// turn off modal when you click continue button
continueButton.addEventListener('click', function () {
  // display none on container
  modal.style.display = 'none';
  // hide screenreader text modal description from screen readers by just display none and w/ aria-hidden just in case
  screenreaderText.style.display = 'none';
  screenreaderText.setAttribute('aria-hidden', 'true');
  // un-fix background
  unfreezeBody();
});

/////////end of modal/////////////

const statewideTotalsData = loadJsonScript('statewide-totals');

//Can return status bars
const opStatElemEl = document.getElementById(
  'operational-status-elementary-bars'
);

new StackedBar({
  target: opStatElemEl,
  props: {
    width: opStatElemEl.offsetWidth,
    title: 'Elementary school students',
    data: statewideTotalsData,
    attrs: [
      {
        key: 'elem_can_in_person_pct',
        name: 'In-person',
        color: SCHOOLS_DARK_BLUE,
      },
      {
        key: 'elem_can_hybrid_pct',
        name: 'Hybrid',
        color: SCHOOLS_LIGHT_BLUE,
      },
      {
        key: 'elem_can_distance_pct',
        name: 'Distance',
        color: SCHOOLS_ORANGE,
      },
    ],
  },
});

const opStatSecEl = document.getElementById(
  'operational-status-secondary-bars'
);

new StackedBar({
  target: opStatSecEl,
  props: {
    width: opStatSecEl.offsetWidth,
    title: 'Secondary school students',
    data: statewideTotalsData,
    attrs: [
      {
        key: 'secondary_can_in_person_pct',
        name: 'In-person',
        color: SCHOOLS_DARK_BLUE,
      },
      {
        key: 'secondary_can_hybrid_pct',
        name: 'Hybrid',
        color: SCHOOLS_LIGHT_BLUE,
      },
      {
        key: 'secondary_can_distance_pct',
        name: 'Distance',
        color: SCHOOLS_ORANGE,
      },
    ],
  },
});

// bars for pcts of students by grade level

const operationalElementaryStudentsTarget = document.getElementById(
  'operational-students-elementary-bars'
);

new StackedBar({
  target: operationalElementaryStudentsTarget,
  props: {
    width: operationalElementaryStudentsTarget.offsetWidth,
    title: 'Elementary school students',
    data: statewideTotalsData,
    attrs: [
      {
        key: 'elem_in_person_pct',
        name: 'In-person',
        color: SCHOOLS_DARK_BLUE,
      },
      {
        key: 'elem_hybrid_pct',
        name: 'Hybrid',
        color: SCHOOLS_LIGHT_BLUE,
      },
      {
        key: 'elem_distance_pct',
        name: 'Distance',
        color: SCHOOLS_ORANGE,
      },
    ],
  },
});
const operationalMiddleStudentsTarget = document.getElementById(
  'operational-students-middle-bars'
);
new StackedBar({
  target: operationalMiddleStudentsTarget,
  props: {
    width: operationalMiddleStudentsTarget.offsetWidth,
    title: 'Secondary school students',
    data: statewideTotalsData,
    attrs: [
      {
        key: 'secondary_in_person_pct',
        name: 'In-person',
        color: SCHOOLS_DARK_BLUE,
      },
      {
        key: 'secondary_hybrid_pct',
        name: 'Hybrid',
        color: SCHOOLS_LIGHT_BLUE,
      },
      {
        key: 'secondary_distance_pct',
        name: 'Distance',
        color: SCHOOLS_ORANGE,
      },
    ],
  },
});

////Bullet chart on how many can vs how many have

const tierData = loadJsonScript('closures-data');
const schoolMapData = loadJsonScript('counties-latest');
new SchoolsMap({
  target: document.getElementById('school-map'),
  props: {
    data: schoolMapData,
    tiers: tierData,
  },
});

const districtTableData = loadJsonScript('districts-latest').map((d) => {
  d.update_date = dateParser(d.update_date);
  return d;
});
new DistrictLookupTable({
  target: document.getElementById('school-district-lookup'),
  props: {
    data: districtTableData,
    is_county: false,
  },
});

new Changelog({
  target: document.getElementById('changelog-container'),
  props: loadJsonScript('changelog-data'),
});
